(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    var checkbox = document.getElementById("gift-wrap-checkbox");
    var fields = document.getElementById("gift-wrap-fields");
    var fromInput = document.getElementById("gift-from");
    var toInput = document.getElementById("gift-to");
    var messageInput = document.getElementById("gift-message");
    var totalPriceElement = document.querySelector(".cart-drawer__total-price"); // Sélecteur du prix total
    var freeShippingBar = document.getElementById("free-shipping-bar"); // La barre de livraison gratuite en haut du panier

    const giftWrapId = 45740834193557; // ID du produit "Emballage cadeau"

    if (!checkbox || !fields) return;

    function updateCartUI() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let cartTotal = cart.total_price / 100; // Converti en euros
                let giftItem = cart.items.find(item => item.id == giftWrapId);

                // Mise à jour de la checkbox et des champs du cadeau
                if (giftItem) {
                    checkbox.checked = true;
                    fields.style.display = "block";
                    fromInput.value = giftItem.properties?.["De la part de"] || "";
                    toInput.value = giftItem.properties?.["Pour"] || "";
                    messageInput.value = giftItem.properties?.["Message"] || "";
                } else {
                    checkbox.checked = false;
                    fields.style.display = "none";
                }

                // Mise à jour du prix total affiché
                if (totalPriceElement) {
                    totalPriceElement.textContent = cartTotal.toFixed(2) + " €";
                }

                // Recharger la barre de livraison gratuite (snippet)
                if (freeShippingBar) {
                    fetch('/?section_id=free-shipping-bar')
                        .then(response => response.text())
                        .then(html => {
                            let parser = new DOMParser();
                            let newDoc = parser.parseFromString(html, 'text/html');
                            let newBar = newDoc.getElementById("free-shipping-bar");
                            if (newBar) {
                                freeShippingBar.innerHTML = newBar.innerHTML;
                            }
                        })
                        .catch(error => console.error("Erreur lors de la mise à jour de la barre de livraison gratuite :", error));
                }
            })
            .catch(error => console.error("Erreur lors de la récupération du panier :", error));
    }

    function handleGiftWrapChange() {
        if (checkbox.checked) {
            fields.style.display = "block";

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: giftWrapId,
                    quantity: 1,
                    properties: {
                        "De la part de": fromInput.value || "",
                        "Pour": toInput.value || "",
                        "Message": messageInput.value || ""
                    }
                })
            })
            .then(() => updateCartUI()) // Mise à jour après ajout
            .catch(error => console.error("Erreur lors de l'ajout :", error));
        } else {
            fields.style.display = "none";

            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    var giftItem = cart.items.find(item => item.id == giftWrapId);
                    if (giftItem) {
                        return fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: giftItem.key,
                                quantity: 0
                            })
                        });
                    }
                })
                .then(() => updateCartUI()) // Mise à jour après suppression
                .catch(error => console.error("Erreur lors de la suppression :", error));
        }
    }

    // Vérification initiale
    updateCartUI();

    // Met à jour la visibilité des champs et le prix total du panier
    checkbox.addEventListener("change", handleGiftWrapChange);

    // Gestion du retour arrière sur **tous les navigateurs** (Chrome, Safari, Firefox)
    window.addEventListener("pageshow", function (event) {
        if (event.persisted) {
            updateCartUI();
        }
    });
});

  } catch(e) { console.error(e); }
})();
})();
